var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-support-overlay is-active" }, [
    _c(
      "div",
      { staticClass: "c-support-wrapper large-text-center" },
      [
        _c(
          "button",
          {
            staticClass: "close-button c-overlay-close-button",
            attrs: { "aria-label": "Close alert", type: "button" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.closeQuoteReveal.apply(null, arguments)
              }
            }
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-accordion-overlay is-succes" },
          [
            _c(
              "h2",
              {
                staticClass:
                  "c-heading-large u-color-white u-padding-vertical-medium",
                class: { "u-no-margin-bottom": _vm.global_element.text }
              },
              [
                _vm._v(
                  _vm._s(_vm.translate("frontend.js.quotation.heading_overlay"))
                )
              ]
            ),
            _vm._v(" "),
            _vm.global_element.text
              ? [
                  _c("p", {
                    staticClass: "u-color-white u-margin-bottom-small",
                    domProps: {
                      innerHTML: _vm._s(_vm.global_element.translated_text)
                    }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.success
              ? _c("div", { staticClass: "u-color-white" }, [
                  _vm._v(_vm._s(_vm.success))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.success
              ? _c(
                  "button",
                  {
                    staticClass: "button outlined",
                    on: { click: _vm.closeQuoteReveal }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.translate("frontend.js.quotation.close_overlay")
                      )
                    )
                  ]
                )
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.error_messages
          ? _c("errors", { attrs: { errors: _vm.error_messages } })
          : _vm._e(),
        _vm._v(" "),
        !_vm.success
          ? _c(
              "form",
              { staticClass: "c-form js-form-animation c-support-form" },
              [
                _c(
                  "ul",
                  {
                    staticClass: "c-accordion js-accordion u-no-margin-bottom"
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass: "c-accordion-item",
                        class: [
                          _vm.step_one_validated && !_vm.edit_step_one
                            ? "is-saved"
                            : "",
                          _vm.step_one_open ? "is-active" : ""
                        ]
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "c-accordion-title-wrapper",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.editStepOne.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "c-accordion-title-inner text-left"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "c-accordion-title c-heading-tiny"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.translate(
                                          "frontend.js.quotation.step_one.heading"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-accordion-title-inner is-edit text-left flex-container align-middle"
                              },
                              [
                                _vm.step_one_open === false &&
                                _vm.step_one_validated === true
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translate(
                                            "frontend.js.quotation.edit"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm.step_one_open === false &&
                                    _vm.step_one_validated === false
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translate(
                                            "frontend.js.quotation.open"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        !this.step_one_validated || _vm.edit_step_one
                          ? _c("div", { staticClass: "c-accordion-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-accordion-content-inner-wrapper"
                                },
                                [
                                  _vm.getStorageBoxImage()
                                    ? _c(
                                        "figure",
                                        {
                                          staticClass:
                                            "c-figure-quotation flex-container align-center"
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "c-figure",
                                            attrs: {
                                              src: _vm.changeImageSize(
                                                _vm.getStorageBoxImage(),
                                                "_",
                                                200
                                              ),
                                              alt: ""
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "c-field-group" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny",
                                          attrs: { for: "type-of-box" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translate(
                                                "frontend.js.quotation.step_one.which_box_needed"
                                              )
                                            ) + " "
                                          ),
                                          _c("u", [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "u-color-white",
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.openAllBoxesPage.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.translate(
                                                      "frontend.js.global.view_all_boxes"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.form.storage_box_id,
                                              expression: "form.storage_box_id"
                                            }
                                          ],
                                          staticClass: "c-select quotation",
                                          class: [
                                            _vm.is_placeholder_one
                                              ? "c-select quotation is-change support"
                                              : "c-select quotation support"
                                          ],
                                          attrs: { id: "type-of-box" },
                                          on: {
                                            change: [
                                              function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.$set(
                                                  _vm.form,
                                                  "storage_box_id",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                              _vm.handleSelectColorOne
                                            ]
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                disabled: "",
                                                selected: ""
                                              },
                                              domProps: { value: null }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.translate(
                                                    "db.js.quotation.type_box"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.storage_boxes, function(
                                            storage_box
                                          ) {
                                            return _c(
                                              "option",
                                              {
                                                domProps: {
                                                  value: storage_box.id
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(storage_box.name) +
                                                    " (" +
                                                    _vm._s(
                                                      storage_box.min_size
                                                    ) +
                                                    "-" +
                                                    _vm._s(
                                                      storage_box.max_size
                                                    ) +
                                                    "m³)"
                                                )
                                              ]
                                            )
                                          })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.storage_box_selection &&
                                      _vm.storage_box_selection.price &&
                                      _vm.storage_box_selection.price_to
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "u-color-white c-field-message"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.translate(
                                                      "frontend.js.quotation.storage_box_price",
                                                      {
                                                        from:
                                                          _vm
                                                            .storage_box_selection
                                                            .price,
                                                        to:
                                                          _vm
                                                            .storage_box_selection
                                                            .price_to
                                                      }
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasError("storage_box_id") &&
                                      _vm.step_one_validated === false
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-field-message is-error u-bold text-left"
                                            },
                                            [
                                              _vm._l(
                                                _vm.getError("storage_box_id"),
                                                function(error) {
                                                  return [_vm._v(_vm._s(error))]
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "c-field-group" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny",
                                        attrs: { for: "quotation-location" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translate(
                                              "frontend.js.quotation.step_one.which_location"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      staticClass:
                                        "c-input-text support readonly",
                                      attrs: {
                                        type: "text",
                                        id: "quotation-location",
                                        readonly: ""
                                      },
                                      domProps: {
                                        value: _vm.establishment.title
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.hasError("establishment_id") &&
                                    _vm.step_one_validated === false
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-field-message is-error u-bold text-left"
                                          },
                                          [
                                            _vm._l(
                                              _vm.getError("establishment_id"),
                                              function(error) {
                                                return [_vm._v(_vm._s(error))]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "c-field-group" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny",
                                          attrs: { for: "start_date_at" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translate(
                                                "frontend.js.quotation.step_one.start_date_at"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.is_loading === false
                                        ? _c("datetimepicker", {
                                            attrs: {
                                              format: "d-m-Y",
                                              timepicker: false,
                                              datepicker: true,
                                              classes:
                                                "c-input-text support valid",
                                              min_date: _vm.min_date,
                                              default_date: _vm.min_date,
                                              max_date: _vm.max_date,
                                              placeholder: _vm.translate(
                                                "frontend.js.contact.date_placeholder"
                                              ),
                                              readonly: ""
                                            },
                                            model: {
                                              value: _vm.form.start_date_at,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "start_date_at",
                                                  $$v
                                                )
                                              },
                                              expression: "form.start_date_at"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasError("start_date_at") &&
                                      _vm.step_one_validated === false
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-field-message is-error u-bold text-left"
                                            },
                                            [
                                              _vm._l(
                                                _vm.getError("start_date_at"),
                                                function(error) {
                                                  return [_vm._v(_vm._s(error))]
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex-container align-right"
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "button is-continue",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.validateStepOne.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translate(
                                                "frontend.js.quotation.next"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.step_one_validated && !_vm.edit_step_one
                          ? _c("div", { staticClass: "c-accordion-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-accordion-content-inner-wrapper flex-container align-middle"
                                },
                                [
                                  _vm.getStorageBoxImage()
                                    ? _c(
                                        "figure",
                                        { staticClass: "c-figure-quotation" },
                                        [
                                          _c("img", {
                                            staticClass: "c-figure",
                                            attrs: {
                                              src: _vm.changeImageSize(
                                                _vm.getStorageBoxImage(),
                                                "_",
                                                200
                                              ),
                                              alt: ""
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "c-accordion-table u-color-white text-left"
                                    },
                                    [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "u-bold u-padding-right-small u-top-align"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translate(
                                                  "frontend.js.quotation.step_one.box_type"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "u-top-align" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.storage_box_selection.name
                                              ) +
                                                " (" +
                                                _vm._s(
                                                  _vm.storage_box_selection
                                                    .min_size
                                                ) +
                                                "-" +
                                                _vm._s(
                                                  _vm.storage_box_selection
                                                    .max_size
                                                ) +
                                                "m³)"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c("td", { attrs: { colspan: "2" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translate(
                                                "frontend.js.quotation.storage_box_price",
                                                {
                                                  from:
                                                    _vm.storage_box_selection
                                                      .price,
                                                  to:
                                                    _vm.storage_box_selection
                                                      .price_to
                                                }
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "u-bold u-padding-right-small u-top-align"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translate(
                                                  "frontend.js.quotation.step_one.location"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "u-top-align" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.establishment_selection
                                                  .title
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "u-bold u-padding-right-small u-top-align"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translate(
                                                  "frontend.js.quotation.step_one.start_date_at"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "u-top-align" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.form.start_date_at)
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "c-accordion-item",
                        class: [
                          _vm.step_two_validated && !_vm.edit_step_two
                            ? "is-saved"
                            : "",
                          _vm.step_two_open ? "is-active" : ""
                        ]
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "c-accordion-title-wrapper",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.editStepTwo.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "c-accordion-title-inner text-left"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "c-accordion-title c-heading-tiny"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.translate(
                                          "frontend.js.quotation.step_two.heading"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-accordion-title-inner is-edit text-left flex-container align-middle"
                              },
                              [
                                _vm.step_two_open === false &&
                                _vm.step_two_validated === true
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translate(
                                            "frontend.js.quotation.edit"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm.step_two_open === false &&
                                    _vm.step_two_validated === false
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translate(
                                            "frontend.js.quotation.open"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.step_two_validated || _vm.edit_step_two
                          ? _c("div", { staticClass: "c-accordion-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-accordion-content-inner-wrapper"
                                },
                                [
                                  _c("div", { staticClass: "c-field-group" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny",
                                        attrs: { for: "quotation-first-name" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translate(
                                              "frontend.js.quotation.step_two.name"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.name,
                                          expression: "form.name"
                                        }
                                      ],
                                      staticClass: "c-input-text support",
                                      attrs: {
                                        type: "text",
                                        id: "quotation-first-name",
                                        placeholder: [
                                          [
                                            _vm.translate(
                                              "frontend.js.quotation.step_two.placeholder.name"
                                            )
                                          ]
                                        ]
                                      },
                                      domProps: { value: _vm.form.name },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.form,
                                            "name",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.hasError("name")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-field-message is-error u-bold text-left"
                                          },
                                          [
                                            _vm._l(
                                              _vm.getError("name"),
                                              function(error) {
                                                return [_vm._v(_vm._s(error))]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "c-field-group" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny",
                                        attrs: { for: "quotation-email" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translate(
                                              "frontend.js.quotation.step_two.email"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.email,
                                          expression: "form.email"
                                        }
                                      ],
                                      staticClass: "c-input-text support",
                                      attrs: {
                                        type: "text",
                                        id: "quotation-email",
                                        placeholder: [
                                          [
                                            _vm.translate(
                                              "frontend.js.quotation.step_two.placeholder.email"
                                            )
                                          ]
                                        ]
                                      },
                                      domProps: { value: _vm.form.email },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.form,
                                            "email",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.hasError("email")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-field-message is-error u-bold text-left"
                                          },
                                          [
                                            _vm._l(
                                              _vm.getError("email"),
                                              function(error) {
                                                return [_vm._v(_vm._s(error))]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "c-field-group" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny",
                                        attrs: { for: "quotation-phone" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translate(
                                              "frontend.js.quotation.step_two.phone"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.phone_number,
                                          expression: "form.phone_number"
                                        }
                                      ],
                                      staticClass: "c-input-text support",
                                      attrs: {
                                        type: "tel",
                                        id: "quotation-phone",
                                        placeholder: [
                                          [
                                            _vm.translate(
                                              "frontend.js.quotation.step_two.placeholder.phone"
                                            )
                                          ]
                                        ]
                                      },
                                      domProps: {
                                        value: _vm.form.phone_number
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.form,
                                            "phone_number",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.hasError("phone_number")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-field-message is-error u-bold text-left"
                                          },
                                          [
                                            _vm._l(
                                              _vm.getError("phone_number"),
                                              function(error) {
                                                return [_vm._v(_vm._s(error))]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "c-field-group" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny",
                                        attrs: { for: "quotation-message" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translate(
                                              "frontend.js.quotation.step_two.message"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.message,
                                          expression: "form.message"
                                        }
                                      ],
                                      staticClass: "c-text-area support",
                                      attrs: {
                                        type: "text-area",
                                        id: "quotation-message",
                                        placeholder: [
                                          [
                                            _vm.translate(
                                              "frontend.js.quotation.step_two.placeholder.message"
                                            )
                                          ]
                                        ]
                                      },
                                      domProps: { value: _vm.form.message },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.form,
                                            "message",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.hasError("message")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-field-message is-error u-bold text-left"
                                          },
                                          [
                                            _vm._l(
                                              _vm.getError("message"),
                                              function(error) {
                                                return [_vm._v(_vm._s(error))]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex-container align-right"
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "button is-continue",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.validateStepTwo.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translate(
                                                "frontend.js.quotation.next"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.step_two_validated && !_vm.edit_step_two
                          ? _c("div", { staticClass: "c-accordion-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-accordion-content-inner-wrapper flex-container flex-dir-column"
                                },
                                [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "c-accordion-table u-color-white text-left",
                                      attrs: { cellspacing: "0" }
                                    },
                                    [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "u-bold u-padding-right-small u-half-width u-top-align"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translate(
                                                  "frontend.js.quotation.step_two.name"
                                                )
                                              ) + ":"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "u-top-align" },
                                          [_vm._v(_vm._s(_vm.form.name))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "u-bold u-padding-right-small u-half-width u-top-align"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translate(
                                                  "frontend.js.quotation.step_two.email"
                                                )
                                              ) + ":"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "u-top-align" },
                                          [_vm._v(_vm._s(_vm.form.email))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "u-bold u-padding-right-small u-half-width u-top-align"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translate(
                                                  "frontend.js.quotation.step_two.phone"
                                                )
                                              ) + ":"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "u-top-align" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.form.phone_number)
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.form.message != null
                                        ? _c("tr", [
                                            _c(
                                              "td",
                                              {
                                                staticClass: "u-top-align",
                                                attrs: { colspan: "2" }
                                              },
                                              [_vm._v(_vm._s(_vm.form.message))]
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "c-accordion-item",
                        class: [
                          _vm.step_three_validated && !_vm.edit_step_three
                            ? "is-saved"
                            : "",
                          _vm.step_three_open ? "is-active" : ""
                        ]
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "c-accordion-title-wrapper",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.editStepThree.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "c-accordion-title-inner text-left"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "c-accordion-title c-heading-tiny"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.translate(
                                          "frontend.js.quotation.step_three.heading"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-accordion-title-inner is-edit text-left flex-container align-middle"
                              },
                              [
                                _vm.step_three_open === false &&
                                _vm.step_three_validated === true
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translate(
                                            "frontend.js.quotation.edit"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm.step_three_open === false &&
                                    _vm.step_three_validated === false
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translate(
                                            "frontend.js.quotation.open"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.step_three_validated || _vm.edit_step_three
                          ? _c("div", { staticClass: "c-accordion-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-accordion-content-inner-wrapper"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "c-field-group text-left" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "u-color-white u-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translate(
                                                "frontend.js.quotation.step_three.appointment_question"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-container flex-dir-column"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-radio-wrapper text-left"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.form
                                                        .question_guided_tour_answer,
                                                    expression:
                                                      "form.question_guided_tour_answer"
                                                  }
                                                ],
                                                staticClass: "c-radio",
                                                attrs: {
                                                  id:
                                                    "quotation-make-appointment-no",
                                                  type: "radio",
                                                  name:
                                                    "quotation-make-appointment",
                                                  value: "no"
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.form
                                                      .question_guided_tour_answer,
                                                    "no"
                                                  )
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.$set(
                                                      _vm.form,
                                                      "question_guided_tour_answer",
                                                      "no"
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "c-radio-label white text-left",
                                                  attrs: {
                                                    for:
                                                      "quotation-make-appointment-no"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.translate(
                                                        "frontend.js.quotation.step_three.no"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-radio-wrapper text-left"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.form
                                                        .question_guided_tour_answer,
                                                    expression:
                                                      "form.question_guided_tour_answer"
                                                  }
                                                ],
                                                staticClass: "c-radio",
                                                attrs: {
                                                  type: "radio",
                                                  id:
                                                    "quotation-make-appointment-yes-location",
                                                  name:
                                                    "quotation-make-appointment",
                                                  value: "yes-location"
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.form
                                                      .question_guided_tour_answer,
                                                    "yes-location"
                                                  )
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.$set(
                                                      _vm.form,
                                                      "question_guided_tour_answer",
                                                      "yes-location"
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "c-radio-label white text-left",
                                                  attrs: {
                                                    for:
                                                      "quotation-make-appointment-yes-location"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.translate(
                                                        "frontend.js.quotation.step_three.yes_location"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.hasError(
                                        "question_guided_tour_answer"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-field-message is-error u-bold text-left"
                                            },
                                            [
                                              _vm._l(
                                                _vm.getError(
                                                  "question_guided_tour_answer"
                                                ),
                                                function(error) {
                                                  return [_vm._v(_vm._s(error))]
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.form.question_guided_tour_answer ==
                                    "yes-location" ||
                                  _vm.form.question_guided_tour_answer ==
                                    "yes-video"
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-field-group u-margin-bottom-small"
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "c-support-field-label u-color-white text-left u-bold u-margin-bottom-tiny",
                                                attrs: { for: "appointment_at" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.translate(
                                                      "frontend.js.quotation.step_three.preference_date"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.is_loading === false
                                              ? _c("datetimepicker", {
                                                  attrs: {
                                                    format: "d-m-Y H:i",
                                                    timepicker: true,
                                                    datepicker: true,
                                                    is_sunday:
                                                      _vm.datetimepicker
                                                        .is_sunday,
                                                    classes:
                                                      "c-input-text support valid",
                                                    step: 30,
                                                    min_date: _vm.min_date,
                                                    default_date: _vm.min_date,
                                                    max_date: _vm.max_date,
                                                    disable_weekends: true,
                                                    time_options:
                                                      _vm.datetimepicker
                                                        .time_options,
                                                    time_options_sunday:
                                                      _vm.datetimepicker
                                                        .time_options_sunday,
                                                    placeholder: _vm.translate(
                                                      "frontend.js.contact.date_placeholder"
                                                    ),
                                                    readonly: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.appointment_at,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "appointment_at",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.appointment_at"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.hasError("appointment_at")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-field-message is-error u-bold text-left"
                                                  },
                                                  [
                                                    _vm._l(
                                                      _vm.getError(
                                                        "appointment_at"
                                                      ),
                                                      function(error) {
                                                        return [
                                                          _vm._v(_vm._s(error))
                                                        ]
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex-container align-center"
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "button is-continue",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.validateStepThree.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translate(
                                                "frontend.js.quotation.check_data"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                2
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.step_three_validated && !_vm.edit_step_three
                          ? _c("div", { staticClass: "c-accordion-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-accordion-content-inner-wrapper flex-container flex-dir-column"
                                },
                                [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "c-accordion-table u-color-white text-left"
                                    },
                                    [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "u-bold u-third-width u-padding-right-small u-top-align"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translate(
                                                  "frontend.js.quotation.step_three.appointment_question"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "u-top-align" },
                                          [
                                            _vm.form
                                              .question_guided_tour_answer ==
                                            "yes-location"
                                              ? [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.translate(
                                                        "frontend.js.quotation.step_three.yes_location"
                                                      )
                                                    )
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.form
                                              .question_guided_tour_answer ==
                                            "yes-video"
                                              ? [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.translate(
                                                        "frontend.js.quotation.step_three.yes_video"
                                                      )
                                                    )
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.form
                                              .question_guided_tour_answer ==
                                            "no"
                                              ? [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.translate(
                                                        "frontend.js.global.no"
                                                      )
                                                    )
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.form.appointment_at != null
                                        ? _c("tr", [
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "u-bold u-third-width u-padding-right-small u-top-align"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.translate(
                                                      "frontend.js.quotation.step_three.preference_date"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "u-top-align" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.form.appointment_at
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm.step_one_validated &&
                    _vm.step_two_validated &&
                    _vm.step_three_validated &&
                    !_vm.edit_step_one &&
                    !_vm.edit_step_two &&
                    !_vm.edit_step_three
                      ? _c("li", [
                          _c("div", { staticClass: "c-accordion-content" }, [
                            _c(
                              "div",
                              {
                                staticClass: "c-accordion-content-inner-wrapper"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-checkbox-wrapper u-margin-top-small"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.is_gdpr,
                                          expression: "form.is_gdpr"
                                        }
                                      ],
                                      staticClass: "c-checkbox",
                                      attrs: {
                                        type: "checkbox",
                                        id: "quotation-terms",
                                        name: "terms"
                                      },
                                      domProps: {
                                        checked: Array.isArray(_vm.form.is_gdpr)
                                          ? _vm._i(_vm.form.is_gdpr, null) > -1
                                          : _vm.form.is_gdpr
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.form.is_gdpr,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.form,
                                                  "is_gdpr",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.form,
                                                  "is_gdpr",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(_vm.form, "is_gdpr", $$c)
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", {
                                      staticClass:
                                        "c-checkbox-label white text-left",
                                      class: { error: _vm.hasError("is_gdpr") },
                                      attrs: { for: "quotation-terms" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.translate(
                                            "frontend.js.global.terms_and_conditions",
                                            {
                                              terms_url:
                                                "/algemene-voorwaarden",
                                              privacy_statement_url:
                                                "/privacybeleid"
                                            }
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.hasError("is_gdpr")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-field-message is-error u-bold text-left"
                                          },
                                          [
                                            _vm._l(
                                              _vm.getError("is_gdpr"),
                                              function(error) {
                                                return [_vm._v(_vm._s(error))]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("vue-recaptcha", {
                                  staticClass:
                                    "flex-container align-center u-margin-top-small",
                                  attrs: { sitekey: this.sitekey },
                                  on: {
                                    verify: _vm.onCaptchaVerified,
                                    expired: _vm.onCaptchaExpired
                                  }
                                }),
                                _vm._v(" "),
                                _vm.hasError("recaptcha")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-field-message is-error u-bold text-left text-center"
                                      },
                                      [
                                        _vm._l(
                                          _vm.getError("recaptcha"),
                                          function(error) {
                                            return [_vm._v(_vm._s(error))]
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex-container align-center"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button is-continue",
                                        attrs: {
                                          type: "submit",
                                          disabled: _vm.disable_submit
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.submitForm.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translate(
                                              "frontend.js.quotation.request"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74843656", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74843656","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/frontend/vue/global/quote-reveal.vue
// module id = 28
// module chunks = 3 4 5 6 7